
import React from 'react';

interface SidebarLogoProps {
  collapsed: boolean;
}

export const SidebarLogo: React.FC<SidebarLogoProps> = ({ collapsed }) => {
  return (
    <div className="p-6 flex-shrink-0 transition-none animate-none">
      {!collapsed ? (
        <h1 className="text-xl font-bold flex items-center transition-none animate-none">
          <img
            src="/arendaplus-logo-full.svg"
            alt="ArendaPro+"
            className="h-6 w-auto shrink-0 select-none pointer-events-none transition-none animate-none"
          />
        </h1>
      ) : (
        <span className="text-xl font-bold text-primary flex items-center justify-center transition-none animate-none">
          <img
            src="/arendaplus-logo-mini.svg"
            alt="A+"
            className="h-6 w-auto shrink-0 select-none pointer-events-none transition-none animate-none"
            style={{ minHeight: '24px' }}
          />
        </span>
      )}
    </div>
  );
};
